import React, { useState } from 'react';
import { Sidebar } from '@/components/Sidebar';
import { ArrowLeft, User, Radio, BarChart3, LineChart, Calendar, FileText, Database, Activity } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function MockupVerticalTabs() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    { id: 'profile', label: 'Channel Profile', icon: User },
    { id: 'overview', label: 'Channel Overview', icon: Radio },
    { id: 'performance', label: 'Channel Performance', icon: BarChart3 },
    { id: 'analytic', label: 'Channel Analytic', icon: LineChart },
    { id: 'activity', label: 'Channel Activity', icon: Calendar },
    { id: 'campaign', label: 'Channel Campaign', icon: FileText },
    { id: 'daily', label: 'Daily Data', icon: Database },
    { id: 'database', label: 'Database Segmentation', icon: Database },
    { id: 'log', label: 'Log', icon: Activity },
  ];

  return (
    <div className="flex min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      <Sidebar />
      <div className="flex-1 flex">
        {/* Vertical Tabs Sidebar */}
        <div className="w-64 bg-[#141416] border-r border-[#2A2A2E] px-4 py-6">
          <div className="flex items-center gap-3 mb-6 px-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/ib-management/list')}
              className="border-[#2A2A2E] hover:border-[#3A3A3F] hover:bg-[#1C1C1F] text-[#F8F9FA] h-8 w-8"
            >
              <ArrowLeft size={16} />
            </Button>
            <div>
              <h2 className="text-lg font-bold font-heading">FIRA IND</h2>
              <p className="text-xs text-[#6C757D]">IB Details</p>
            </div>
          </div>

          <div className="space-y-1">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 ${
                    isActive
                      ? 'bg-[#E63946]/20 text-[#E63946] border border-[#E63946]/40'
                      : 'text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]'
                  }`}
                >
                  <Icon size={16} />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 px-6 py-6">
          <div className="border border-[#06D6A0] bg-[#06D6A0]/5 rounded-lg p-6 mb-6">
            <h2 className="text-xl font-semibold text-[#06D6A0] mb-2">✨ SOLUTION 1: VERTICAL SIDE TABS</h2>
            <p className="text-[#ADB5BD]">Tabs di sebelah kiri content - macam VS Code, Notion, Linear</p>
          </div>

          <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
            <h3 className="text-2xl font-semibold mb-4">Content for: {tabs.find(t => t.id === activeTab)?.label}</h3>
            <p className="text-[#ADB5BD] mb-6">Klik tabs di sebelah kiri untuk switch content</p>
            
            <div className="grid grid-cols-4 gap-4">
              <div className="border border-[#2A2A2E] rounded p-4">
                <p className="text-xs text-[#ADB5BD]">Sample Metric</p>
                <p className="text-2xl font-mono text-[#F8F9FA]">123,456</p>
              </div>
              <div className="border border-[#2A2A2E] rounded p-4">
                <p className="text-xs text-[#ADB5BD]">Sample Metric</p>
                <p className="text-2xl font-mono text-[#F8F9FA]">78.90</p>
              </div>
              <div className="border border-[#2A2A2E] rounded p-4">
                <p className="text-xs text-[#ADB5BD]">Sample Metric</p>
                <p className="text-2xl font-mono text-[#F8F9FA]">456</p>
              </div>
              <div className="border border-[#2A2A2E] rounded p-4">
                <p className="text-xs text-[#ADB5BD]">Sample Metric</p>
                <p className="text-2xl font-mono text-[#F8F9FA]">MYR 89k</p>
              </div>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="border border-[#06D6A0] bg-[#06D6A0]/5 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-[#06D6A0] mb-2">✅ KELEBIHAN:</h3>
              <ul className="text-xs text-[#ADB5BD] space-y-1">
                <li>• Scalable - boleh 20+ tabs</li>
                <li>• Better readability - full labels</li>
                <li>• Professional & modern</li>
                <li>• Natural eye flow (vertical)</li>
                <li>• Exclusive SaaS aesthetic</li>
              </ul>
            </div>
            <div className="border border-[#E63946] bg-[#E63946]/5 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-[#E63946] mb-2">⚠️ PERTIMBANGAN:</h3>
              <ul className="text-xs text-[#ADB5BD] space-y-1">
                <li>• Takes more horizontal space</li>
                <li>• Different pattern dari common tabs</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}